module.exports = __webpack_public_path__ + "images/rich_heading/other/baby_goods/icon_f793b9ff0b8678425064fb0530a51e00.png";